import React, { useState } from 'react';
import { width100 } from '../../../settings/otherStyles';
import { Form } from 'formik';
import Autocomplete from "../../../common/components/base/Autocomplete";
import { durations } from "../../../settings/dataSets";
import LoadingAnimation from "../../../common/components/base/LoadingAnimation";
import { useSimulation } from '../../../hooks/useSimulation';
import TextField from '@material-ui/core/TextField';
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const CampaignFormSimulation = (props) => {
  const { setFieldValue, values, isSubmitting, handleTab } = props;
  const [currentTab, setCurrentTab] = useState(0);
  
  // Fetch advertisers simulation data
  const { data: advertisersData, isLoading: isLoadingAdvertisers, error: errorAdvertisers } = useSimulation('ad');

  const handleChange = (event, newTab) => {
    setCurrentTab(newTab);
  };

  const handleTabClick = (values) => {
    if (!isSubmitting && handleTab) {
      handleTab(values);
    }
  };

  return (
    <div>
      <Card>
        <div>
          <AppBar position="static" color="default">
            <Tabs value={currentTab} onChange={handleChange}>
              <Tab disableRipple label="Campaign" />
              <Tab disableRipple label="Line Items"
                disabled={!values.name}
              />
            </Tabs>
          </AppBar>
        </div>
        <Form>
          <CardContent>
            {currentTab === 0 && <div className="row justify-content-center">
              <div className="col-lg-10 mt-3">
                <div className="input-group form-control-lg">
                  <div className="form-group bmd-form-group">
                    <TextField
                      required
                      id="campaignName"
                      label="Name"
                      name="name"
                      defaultValue={values.name}
                      placeholder="campaignname_brand_period"
                      onChange={e => setFieldValue("name", e.target.value)}
                      margin="normal"
                      style={width100}
                    />
                  </div>
                </div>
                <div className="input-group form-control-lg">
                  <div className="form-group bmd-form-group">
                    <Autocomplete single={values.duration} handleChange={(item) => item ? setFieldValue("scheduleDuration", item.label) : setFieldValue("scheduleDuration", "")}
                      key="1" values={durations} placeholder="Schedule Duration" />
                  </div>
                </div>
                <div className="input-group form-control-lg">
                  <div className="form-group bmd-form-group">
                    {isLoadingAdvertisers && <LoadingAnimation />}
                    {errorAdvertisers && <div>Error loading advertisers: {errorAdvertisers.message}</div>}
                    {advertisersData && advertisersData.advertisersSimulation && (
                      <Autocomplete key="3" placeholder="Advertiser"
                        handleChange={(item) => item ? setFieldValue("advertiser", item.label) : setFieldValue("advertiser", "")}
                        values={advertisersData.advertisersSimulation.map(value => ({
                          value: value._id,
                          label: value.name
                        }))} />
                    )}
                  </div>
                </div>
              </div>
            </div>}
            {currentTab === 1 && <div>
              <div>
              </div>
            </div>}
            <div className="card-footer">
              <div className="ml-auto">
                {
                  currentTab === 0 &&
                  <button className="btn btn-fill btn-rose"
                    disabled={isSubmitting}
                    onClick={() => handleTabClick(values)}>Next</button>
                }
              </div>
              <div className="ml-auto mr-auto">
              </div>
              <div className="clearfix"></div>
            </div>
          </CardContent>
        </Form>
      </Card>
    </div>
  );
};

export default CampaignFormSimulation;
